import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Field } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { H1, Span, InputRadio, P, Spinner, ButtonV2 } from 'shared';
import { usePostServicingV1AccountsLenderAccountIdentifierBankAccountsMutation } from 'servicing-api';
import { toastError, toastSuccess } from 'utils';
import { setSelectedBankAccount } from '../actions';
import { FlowActions } from '../components';
import { BANK_ACCOUNT_PARAM, CHANGE_BANK_ACCOUNT_PARAM } from '../constants';
import { useAuthorizationToken, useFlexFinalizeData, useFlowPath, } from '../hooks';
import { selectors } from '../reducer';
import { getPostBankConnectionRoute, isChangingBankAccount } from '../utils';
function AutopayAccountSelection() {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const isChangingAccount = isChangingBankAccount(location.search);
    const authorizationToken = useAuthorizationToken();
    const flowPath = useFlowPath(authorizationToken);
    const { lenderAccountIdentifier, finalizeData } = useFlexFinalizeData(authorizationToken);
    const bankAccounts = useSelector((state) => selectors.bankAccounts(state));
    const [postBankAccount, { isLoading }] = usePostServicingV1AccountsLenderAccountIdentifierBankAccountsMutation();
    const handleSubmit = async (values) => {
        const selectedAccount = bankAccounts.find((account) => account.id?.toString() === values.account);
        if (selectedAccount && lenderAccountIdentifier) {
            try {
                const created = await postBankAccount({
                    lenderAccountIdentifier,
                    postServicingV1AccountsLenderAccountIdentifierBankAccounts: {
                        plaidBankAccountId: selectedAccount.id,
                    },
                }).unwrap();
                dispatch(setSelectedBankAccount(selectedAccount));
                const nextRoute = isChangingAccount
                    ? '/autopay'
                    : getPostBankConnectionRoute(finalizeData);
                if (isChangingAccount)
                    toastSuccess('Bank Account Updated');
                history.push(flowPath(nextRoute, created.id
                    ? { [BANK_ACCOUNT_PARAM]: String(created.id) }
                    : undefined));
            }
            catch (error) {
                toastError('Unable to connect your bank account. Please try again.');
            }
        }
    };
    const AccountCard = ({ account, }) => {
        return (_jsxs("div", { className: "autopay-account-card", children: [_jsx(Field, { name: "account", value: account.id?.toString(), component: InputRadio, type: "radio", className: "cursor-pointer" }), _jsxs("div", { className: "autopay-account-card-content mar-left-10", children: [_jsx("div", { className: "mar-b-8", children: _jsx(Span, { variant: "body-large", bold: true, children: "Bank Account" }) }), _jsx("div", { className: "", children: _jsxs(Span, { variant: "body-large", children: ["Ending in ", account.accountId?.slice(-4)] }) })] })] }));
    };
    if (!lenderAccountIdentifier) {
        return (_jsx("div", { className: "text-center", children: _jsx(Spinner, {}) }));
    }
    if (!bankAccounts || bankAccounts.length === 0) {
        return (_jsx(Redirect, { to: flowPath('/autopay', isChangingAccount ? { [CHANGE_BANK_ACCOUNT_PARAM]: '1' } : undefined) }));
    }
    return (_jsxs("div", { className: "flex-finalize-autopay-auth", children: [_jsxs("div", { className: "header-container", children: [_jsx(H1, { variant: "headline-large", children: "Select Bank Account" }), _jsx(P, { variant: "title-large", children: "Select the account you'd like to use for autopay enrollment." })] }), _jsx("div", { className: "autopay-auth-container", children: _jsx(Form, { onSubmit: handleSubmit, render: ({ handleSubmit }) => (_jsxs("form", { onSubmit: handleSubmit, children: [_jsx("fieldset", { children: bankAccounts.map((account) => (_jsx(AccountCard, { account: account }, account.id))) }), _jsx(FlowActions, { children: _jsx(ButtonV2, { type: "submit", variant: "filled", color: "orange-flex", size: "medium", hugText: true, overwriteCasing: true, submitting: isLoading, children: "Continue" }) })] })) }) })] }));
}
export default AutopayAccountSelection;
